module.exports = __webpack_public_path__ + "img/complex-residence-small.83ba876a.png";